{
  "page_count": "od {n, plural, one{# stran} other{# strani}}"
}
